import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { AnimatedValue } from '../../../../components/AnimatedValue';
import { quoteWith } from '../model/capabilities';
import type { Outcome } from '../model/types';

function percent(probability: number): string {
    return `${(probability * 100).toFixed(1)}%`;
}

interface LiveProbabilityProps {
    outcome: Outcome;
    sx?: SxProps<Theme>;
}

/**
 * The probability of an outcome. A streamed price flashes green when it rises
 * and red when it falls; a loaded price never flashes.
 */
export function LiveProbability({ outcome, sx }: LiveProbabilityProps) {
    const quote = quoteWith(outcome, 'probability');
    const probability = quote?.probability ?? null;
    if (probability === null) return <Typography sx={sx}>–</Typography>;
    return (
        <AnimatedValue
            value={probability}
            format={percent}
            trigger={quote?.live ? probability : null}
            sx={sx}
        />
    );
}
